import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    findingID?: String,
    finding? : String,
    filterSummary? : any
}

export const updateFindingDetail = ({
    findingID,
    finding,
    filterSummary,
    eventEmitter,
}: Props) => {
    eventEmitter.emit(Event.updateFindingDetail, {findingID, finding, filterSummary});
  
};

